import { Autocomplete, Grid, TextField } from '@mui/material';
import { createInvoicePageSelectors, getSelectorAttribute } from '@vy/app-selectors';
import { withDefault } from '@vy/utils';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useCustomersOverviews } from '../../../../hooks/requests/use-customers-overviews/use-customers-overviews';
import type { InvoiceFormInput } from './CreateInvoiceForm/create-invoice-form-types/invoice-form-input';

export const CustomerSelect: React.FC = () => {
  const { control } = useFormContext<InvoiceFormInput>();
  const { data: customersOverviewsResponse } = useCustomersOverviews({ suspense: true });
  const customers = withDefault(customersOverviewsResponse?.customers, []);

  return (
    <Grid>
      <Controller
        control={control}
        name="settings.customerId"
        render={({ field }) => (
          <Autocomplete
            fullWidth
            autoHighlight
            size="small"
            disableClearable
            options={customers}
            renderInput={(params) => (
              <TextField
                {...params}
                slotProps={{
                  ...params.slotProps,

                  htmlInput: {
                    ...params.slotProps.htmlInput,
                    autoComplete: 'new-password',
                  }
                }}
              />
            )}
            getOptionLabel={(customer) => customer.name}
            onChange={(_, newValue) => {
              field.onChange(newValue.id);
            }}
            value={customers.find((customer) => customer.id === field.value)}
            {...getSelectorAttribute(createInvoicePageSelectors.settings.customerSelect)}
          />
        )}
      />
    </Grid>
  );
};
